// Lib
import MousetrapModule from 'mousetrap';

const Mousetrap = MousetrapModule?.default || MousetrapModule;
const originalStopCallback = Mousetrap?.prototype?.stopCallback;

/**
 * Prevent all Mousetrap handlers.
 */
Mousetrap.pause = () => {
    if (!Mousetrap?.prototype) return;

    Mousetrap.prototype.stopCallback = () => true;
};

/**
 * Resume all Mousetrap handlers.
 */
Mousetrap.resume = () => {
    if (!Mousetrap?.prototype) return;

    Mousetrap.prototype.stopCallback = originalStopCallback;
};

export default Mousetrap;
